import { assign as _assign } from 'lodash';
import { FSA } from 'flux-standard-action';
import { DynamicTitlesPayload, dynamicTitlesActionTypes } from './dynamic-titles.action';
import { randomHash } from '../utils';

export interface DynamicTitlesProps {
  hash: string;
  title: string;
}

export interface DynamicTitlesState {
  dashboard?: DynamicTitlesProps;
  page?: DynamicTitlesProps;
}

export const titlesInitialState = {
  dashboard: undefined,
  page: undefined,
};

export const dynamicTitlesReducer = (
  state: DynamicTitlesState = titlesInitialState, 
  action: FSA<dynamicTitlesActionTypes, DynamicTitlesPayload>
): DynamicTitlesState => {
  switch (action.type) {
    case dynamicTitlesActionTypes.add:
      return !action.payload ? state : addTitleToState(state, action.payload);

    case dynamicTitlesActionTypes.clear:
      return titlesInitialState;

    case dynamicTitlesActionTypes.remove:
      return !action.payload ? state : removeTitleFromState(state, action.payload);

    default:
      return state;
  }
};

const addTitleToState = (state: DynamicTitlesState, payload?: DynamicTitlesPayload): DynamicTitlesState => {
  if (!payload) {
    return state;
  }
  return _assign<DynamicTitlesState, {[key: string]: DynamicTitlesProps}>(state, {
    [payload.key]: {
      hash: randomHash(30),
      title: (payload.value as string),
    }
  });
};

const removeTitleFromState = (state: DynamicTitlesState, payload?: DynamicTitlesPayload): DynamicTitlesState => {
  if (!payload) {
    return state;
  }
  return _assign<DynamicTitlesState, {[key: string]: undefined}>(state, {
    [payload.key]: undefined,
  });
};
